document.addEventListener('DOMContentLoaded', () => {
  const cartSection = document.querySelector('.cart-page');
  if (!cartSection) return;

  const discountStorageKey = 'tglDiscountCode';
  const drawerStateKey = 'tglCartDrawerOpen';

  const applyDiscount = (code) => {
    if (!code) return;
    localStorage.setItem(discountStorageKey, code);
    localStorage.setItem(drawerStateKey, 'true');
    const redirect = encodeURIComponent(`${window.location.pathname}${window.location.search}${window.location.hash}`);
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${redirect}`;
  };

  const getStoredDiscount = () => localStorage.getItem(discountStorageKey);

  const syncStoredDiscount = () => {
    const summary = cartSection.querySelector('[data-cart-discount-active]');
    if (!summary) return;
    const hasDiscount = summary.dataset.cartDiscountActive === 'true';
    const discountCode = summary.dataset.cartDiscountCode || '';
    if (!hasDiscount) {
      localStorage.removeItem(discountStorageKey);
      return;
    }
    if (discountCode && !getStoredDiscount()) {
      localStorage.setItem(discountStorageKey, discountCode);
    }
  };

  const goToCheckoutWithDiscount = (code) => {
    if (!code) return false;
    window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
    return true;
  };

  function updateQuantity(itemId, quantity) {
    const payload = { updates: { [itemId]: quantity } };

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then((response) => response.json())
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
      });
  }

  cartSection.querySelectorAll('.quantity-btn').forEach((button) => {
    button.addEventListener('click', () => {
      const action = button.dataset.action;
      const itemId = button.dataset.itemId;
      const input = cartSection.querySelector(`.quantity-input[data-item-id="${itemId}"]`);
      const currentValue = parseInt(input.value, 10) || 1;

      if (action === 'increase') {
        updateQuantity(itemId, currentValue + 1);
      } else if (action === 'decrease' && currentValue > 1) {
        updateQuantity(itemId, currentValue - 1);
      }
    });
  });

  cartSection.querySelectorAll('.quantity-input').forEach((input) => {
    input.addEventListener('change', () => {
      const itemId = input.dataset.itemId;
      const newQuantity = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = newQuantity;
      updateQuantity(itemId, newQuantity);
    });
  });

  cartSection.querySelectorAll('.item-remove').forEach((button) => {
    button.addEventListener('click', () => {
      const itemId = button.dataset.itemId;
      updateQuantity(itemId, 0);
    });
  });

  cartSection.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-discount-form]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('[data-discount-input]');
    const code = input ? input.value.trim() : '';
    applyDiscount(code);
  });

  cartSection.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest('.checkout-btn');
    if (!checkoutButton) return;
    const code = getStoredDiscount();
    if (!code) return;
    event.preventDefault();
    goToCheckoutWithDiscount(code);
  });

  syncStoredDiscount();
});
